module.exports = __webpack_public_path__ + "img/home-background-v4.256198ff.png";